export default "__VITE_ASSET__Dp4Nuy_8__"